<div
	[hidden]="direction"
	class="resize-handle topleft resize-top resize-left"
	(mousedown)="onMouseEvent($event, 'nw')"
></div>
<div
	[hidden]="direction"
	class="resize-handle topright resize-top resize-right"
	(mousedown)="onMouseEvent($event, 'ne')"
></div>

<div
	[hidden]="direction === 'horizontal'"
	class="resize-handle topmiddle resize-top"
	(mousedown)="onMouseEvent($event, 'n')"
></div>
<div
	[hidden]="direction === 'horizontal'"
	class="resize-handle bottommiddle resize-bottom"
	(mousedown)="onMouseEvent($event, 's')"
></div>

<div
	[hidden]="direction === 'vertical'"
	class="resize-handle leftmiddle resize-left"
	(mousedown)="onMouseEvent($event, 'w')"
></div>
<div
	[hidden]="direction === 'vertical'"
	class="resize-handle rightmiddle resize-right"
	(mousedown)="onMouseEvent($event, 'e')"
 ></div>

<div
	[hidden]="direction"
	class="resize-handle bottomleft resize-bottom resize-left"
	(mousedown)="onMouseEvent($event, 'sw')"
></div>
<div
	[hidden]="direction"
	class="resize-handle bottomright resize-bottom resize-right"
	(mousedown)="onMouseEvent($event, 'se')"
></div>
